import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Modal } from "app/components/Modal";
import { DropdownIcon } from "app/icons";
import React from "react";

import {
  CATEGORY_OPTIONS,
  useAddPriceModal,
} from "../../hooks/useAddPriceModal";
import { useStyles } from "./styles";

const AddPriceModal = () => {
  const styles = useStyles();
  const {
    t,
    isOpen,
    form,
    isLoading,
    isValid,
    onClose,
    setField,
    onSubmit,
    label,
    categoryLabel,
  } = useAddPriceModal();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>
            {label("ADD_TITLE")}
          </Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            disabled={isLoading}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <Box className={styles.field}>
            <Typography className={styles.label}>
              {label("FIELDS.CATEGORY")}
            </Typography>
            <TextField
              className={styles.input}
              fullWidth
              select
              variant="outlined"
              value={form.category}
              disabled={isLoading}
              InputProps={{ notched: false }}
              SelectProps={{
                displayEmpty: true,
                IconComponent: DropdownIcon,
                MenuProps: {
                  disableScrollLock: true,
                  PaperProps: { className: styles.selectMenuPaper },
                  MenuListProps: { className: styles.selectMenuList },
                },
                renderValue: (value) => {
                  const selected = String(value || "");
                  if (!selected) {
                    return (
                      <span className={styles.selectPlaceholder}>
                        {label("PLACEHOLDERS.SELECT_CATEGORY")}
                      </span>
                    );
                  }
                  return categoryLabel(selected);
                },
              }}
              onChange={(event) => setField("category", event.target.value)}
            >
              <MenuItem value="" disabled className={styles.menuItem}>
                {label("PLACEHOLDERS.SELECT_CATEGORY")}
              </MenuItem>
              {CATEGORY_OPTIONS.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  className={styles.menuItem}
                >
                  {categoryLabel(option)}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Box className={styles.field}>
            <Typography className={styles.label}>
              {label("FIELDS.ITEM_ID")}
            </Typography>
            <TextField
              className={styles.input}
              fullWidth
              variant="outlined"
              placeholder={label("PLACEHOLDERS.ENTER_ITEM_ID")}
              value={form.itemId ? String(form.itemId) : ""}
              disabled={isLoading}
              inputMode="numeric"
              InputProps={{ notched: false }}
              onChange={(event) => setField("itemId", event.target.value)}
            />
          </Box>

          <Box className={styles.fieldRow}>
            <Box className={styles.field}>
              <Typography className={styles.label}>
                {label("FIELDS.UNIT")}
              </Typography>
              <TextField
                className={styles.input}
                fullWidth
                variant="outlined"
                placeholder={label("PLACEHOLDERS.ENTER_UNIT")}
                value={form.unit}
                disabled={isLoading}
                InputProps={{ notched: false }}
                onChange={(event) => setField("unit", event.target.value)}
              />
            </Box>
            <Box className={styles.field}>
              <Typography className={styles.label}>
                {label("FIELDS.BASE_PRICE")}
              </Typography>
              <TextField
                className={styles.input}
                fullWidth
                variant="outlined"
                placeholder={label("PLACEHOLDERS.ENTER_BASE_PRICE")}
                value={form.basePrice}
                disabled={isLoading}
                inputMode="numeric"
                InputProps={{ notched: false }}
                onChange={(event) => setField("basePrice", event.target.value)}
              />
            </Box>
          </Box>
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            disabled={isLoading}
            onClick={onClose}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!isValid || isLoading}
            onClick={onSubmit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddPriceModal;
